module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-batch-list"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_vm._t("default"), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$tx('操作', 'xpc.common.operation'),
      "fixed": "right",
      "sortable": "",
      "prop": "operation",
      "align": _vm.align,
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operation"
        }, [(!scope.row.isEdit) ? _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$tx('编辑', 'xpc.common.edit')) + "\n          ")]) : _c('rt-button', {
          attrs: {
            "text": "",
            "type": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.add(scope)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$tx('添加', 'xpc.common.add')) + "\n          ")]), _vm._v(" "), _c('rt-divider', {
          attrs: {
            "direction": "vertical"
          }
        }), _vm._v(" "), _c('rt-popconfirm', {
          attrs: {
            "title": _vm.$tx('确定需要删除这条内容吗？', 'xpc.common.comfirmDelete')
          },
          on: {
            "confirm": function($event) {
              return _vm.onConfirm(scope.$index)
            }
          }
        }, [_c('rt-button', {
          attrs: {
            "slot": "reference",
            "text": "",
            "type": "plain"
          },
          slot: "reference"
        }, [_vm._v("\n              " + _vm._s(_vm.$tx('删除', 'xpc.common.delete')) + "\n            ")])], 1)], 1)]
      }
    }])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addBtn
    }
  }, [_c('rt-icon', {
    attrs: {
      "color": _vm.SCSS_VARIABLES.NEUTRAL_COLOR_REGULAR,
      "name": "rt-base-plus"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$tx('添加', 'xpc.common.add')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9139bd7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/batchList/rtBatchList.vue
// module id = 2142
// module chunks = 228